// src/auth/TestbedGate.jsx
import React, { useMemo } from 'react';
import { Alert } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { selectTestbed, setTestbed } from '../slices/testbedSlice';
import { keycloak } from '../auth/keycloak';
import { resolveTestbedFromGroups, isAdminFromGroups } from '../auth/groupToTestbed';

export default function TestbedGate({ children }) {
  const tb = useSelector(selectTestbed);
  const dispatch = useDispatch();

  const groups = keycloak?.tokenParsed?.groups || [];
  const allowed = useMemo(() => resolveTestbedFromGroups(groups), [groups]);
  const isAdmin = isAdminFromGroups(groups);

  // INTRA/TMA users with exactly one testbed → auto-pick, no UI change
  if (!tb && allowed.length === 1) {
    dispatch(setTestbed(allowed[0]));
    return null; // render nothing while setting
  }

  // Admin (has both) with no selection yet → tell them to use navbar switcher
  if (!tb && isAdmin) {
    return (
      <div style={{ padding: 24 }}>
        <Alert
          type="info"
          message="Select a testbed"
          description="Use the testbed switcher in the top navbar to choose INTRA or TMA."
          showIcon
        />
      </div>
    );
  }

  // No testbed and not admin (edge case with zero allowed)
  if (!tb) {
    return (
      <div style={{ padding: 24 }}>
        <Alert
          type="warning"
          message="No testbed available"
          description="Your account doesn’t have a mapped testbed. Please contact an administrator."
          showIcon
        />
      </div>
    );
  }

  return children;
}
